import type React from "react";
import { ChatSearchModal } from "@/features/chat/components/ChatSearchModal";
import { CreateChatModal } from "@/features/chat/components/CreateChatModal";
import type { User, UserShort } from "@/lib/humhub-api/types";

interface ChatModalsProps {
  isSearchModalOpen: boolean;
  isCreateChatModalOpen: boolean;
  selectedUserForChat?: User;
  createModalUser?: User;
  searchModalInitialMode?: "keyword" | "participants";
  searchModalInitialParticipants?: UserShort[];
  onChatRoomSelect: (roomId: number | undefined) => void;
  onCreateNewChat: (selectedUser?: User) => void;
  onCloseSearchModal: () => void;
  onCloseCreateModal: () => void;
}

export const ChatModals: React.FC<ChatModalsProps> = ({
  isSearchModalOpen,
  isCreateChatModalOpen,
  selectedUserForChat,
  createModalUser,
  searchModalInitialMode,
  searchModalInitialParticipants,
  onChatRoomSelect,
  onCreateNewChat,
  onCloseSearchModal,
  onCloseCreateModal,
}) => {
  return (
    <>
      <ChatSearchModal
        isOpen={isSearchModalOpen}
        onClose={onCloseSearchModal}
        onChatRoomSelect={onChatRoomSelect}
        onCreateNewChat={onCreateNewChat}
        initialUser={selectedUserForChat}
        initialSearchMode={searchModalInitialMode}
        initialParticipants={searchModalInitialParticipants}
      />

      <CreateChatModal
        isOpen={isCreateChatModalOpen}
        onClose={onCloseCreateModal}
        initialUser={createModalUser}
      />
    </>
  );
};
